import React from 'react';

export const CategoryInsightsSettingsContext = React.createContext({});
